import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8131776"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "При обработке файла импорта обнаружены направления, которые невозможно импортировать.", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ExcelModal__text" }, " Для закрепления дочерних направлений, отмеченных галочкой, нажмите “Подтвердить”, либо внесите изменения в файл / систему и повторите попытку: ", -1))
const _hoisted_3 = { class: "w-full border-collapse" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Дочернее направление"),
    /*#__PURE__*/_createElementVNode("th", null, "Результат импорта")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_6 = {
  key: 1,
  class: "fas fa-times"
}
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "Tabs" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "Directions"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Directions__placeholder" }, "Город отправления", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Directions__placeholder" }, "Город назначения", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Directions__placeholder" }, "Зона доставки", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Directions__placeholder" }, "Логист", -1))
const _hoisted_16 = {
  key: 1,
  class: "Sla"
}
const _hoisted_17 = { class: "flex items-center justify-end mb-3" }
const _hoisted_18 = {
  key: 0,
  class: "Sla__table"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-white text-black font-bold" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Тариф"),
    /*#__PURE__*/_createElementVNode("th", null, "Период"),
    /*#__PURE__*/_createElementVNode("th", null, "Забор"),
    /*#__PURE__*/_createElementVNode("th", null, "Обработка"),
    /*#__PURE__*/_createElementVNode("th", null, "Транзит"),
    /*#__PURE__*/_createElementVNode("th", null, "Доставка")
  ])
], -1))
const _hoisted_20 = {
  key: 0,
  class: "TitleTd font-semibold align-middle",
  rowspan: "2"
}
const _hoisted_21 = { class: "TitleTd" }
const _hoisted_22 = {
  key: 1,
  class: "Sla__table"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-white text-black font-bold" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Тариф"),
    /*#__PURE__*/_createElementVNode("th", null, "Период"),
    /*#__PURE__*/_createElementVNode("th", null, "Забор"),
    /*#__PURE__*/_createElementVNode("th", null, "Обработка"),
    /*#__PURE__*/_createElementVNode("th", null, "Транзит"),
    /*#__PURE__*/_createElementVNode("th", null, "Доставка")
  ])
], -1))
const _hoisted_24 = {
  key: 0,
  class: "TitleTd font-semibold align-middle",
  rowspan: "2"
}
const _hoisted_25 = { class: "TitleTd" }
const _hoisted_26 = {
  key: 2,
  class: "Cost"
}
const _hoisted_27 = { class: "Table" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "TableHeader" }, [
  /*#__PURE__*/_createElementVNode("div", null, "20-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "10-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "5-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "3-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "Газель")
], -1))
const _hoisted_29 = { class: "TableBody" }
const _hoisted_30 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Вес:", -1))
const _hoisted_32 = { class: "mt-2 grid grid-cols-2 gap-3 items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Кубатура:", -1))
const _hoisted_34 = {
  key: 3,
  class: "Internal"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Internal__text" }, " Загрузите файл со списком дочерних направлений для закрепления их за данным родителем. ", -1))
const _hoisted_36 = {
  class: "Internal__download",
  href: "/Шаблон_для_дочерних_направлений.xlsx",
  download: "Шаблон_для_дочерних_направлений.xlsx"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "LinkText" }, " Скачать шаблон импорта ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Перетащите файл в это окно или", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Internal__upload" }, "выберите его на вашем устройстве", -1))
const _hoisted_40 = {
  key: 0,
  class: "Internal__files"
}
const _hoisted_41 = { class: "flex-1" }
const _hoisted_42 = { class: "text-gray-800 font-medium truncate" }
const _hoisted_43 = { class: "text-sm text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_export_icon = _resolveComponent("export-icon")!
  const _component_upload_icon = _resolveComponent("upload-icon")!
  const _component_excel_icon = _resolveComponent("excel-icon")!
  const _component_times_grey_icon = _resolveComponent("times-grey-icon")!

  return (_ctx.state.excel_response.length)
    ? (_openBlock(), _createBlock(_component_new_modal, {
        key: 0,
        title: "Обработка файла импорта",
        loading: _ctx.loading || _ctx.state.is_loading,
        class: "ExcelModal",
        "with-cancel-button": "",
        onSubmit: _ctx.onSubmitExcel,
        onCancel: _ctx.cancelExcel
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _createElementVNode("table", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.excel_response, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `excelRow-${index}`,
                  class: _normalizeClass(item.isSuccess ? 'bg-green-100' : 'bg-red-100')
                }, [
                  _createElementVNode("td", null, [
                    (item.isSuccess)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                      : (_openBlock(), _createElementBlock("i", _hoisted_6))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.fromCityName) + " - " + _toDisplayString(item.whereCityName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.reason), 1)
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading", "onSubmit", "onCancel"]))
    : (_openBlock(), _createBlock(_component_new_modal, {
        key: 1,
        title: _ctx.title,
        loading: _ctx.loading,
        onSubmit: _ctx.emitManager,
        onCancel: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_loader, { class: "primary" })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TABS, (tab) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["Tabs__tab", { active: _ctx.tabs_state.id === tab.id }]),
                      key: `tab-${tab.id}`,
                      onClick: ($event: any) => (_ctx.selectTab(tab))
                    }, _toDisplayString(tab.label), 11, _hoisted_10))
                  }), 128))
                ]),
                (_ctx.isDirection)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _hoisted_12,
                        _createVNode(_component_new_select, {
                          placeholder: "Город отправления",
                          value: _ctx.payload.fromCityId,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.fromCityId) = $event)),
                          disabled: _ctx.loading || _ctx.isUpdate,
                          options: _ctx.data_state.cities.list,
                          loading: _ctx.data_state.cities.is_loading,
                          failed: _ctx.data_state.cities.is_failed,
                          "is-invalid": _ctx.validation$.fromCityId.$error,
                          "validation-errors": _ctx.validation$.fromCityId.$errors,
                          "error-text": "При получении списка городов произошла ошибка",
                          "can-deselect": "",
                          onRefresh: _ctx.loadCities
                        }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_13,
                        _createVNode(_component_new_select, {
                          placeholder: "Выберите из списка",
                          value: _ctx.payload.whereCityId,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payload.whereCityId) = $event)),
                          disabled: _ctx.loading || _ctx.isUpdate,
                          options: _ctx.data_state.cities.list,
                          loading: _ctx.data_state.cities.is_loading,
                          failed: _ctx.data_state.cities.is_failed,
                          "is-invalid": _ctx.validation$.whereCityId.$error,
                          "validation-errors": _ctx.validation$.whereCityId.$errors,
                          "error-text": "При получении списка городов произошла ошибка",
                          "can-deselect": "",
                          onRefresh: _ctx.loadCities
                        }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_14,
                        _createVNode(_component_new_select, {
                          value: _ctx.payload.zoneId,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payload.zoneId) = $event)),
                          placeholder: "Выберите из списка",
                          disabled: _ctx.loading,
                          options: _ctx.data_state.zones.list,
                          loading: _ctx.data_state.zones.is_loading,
                          failed: _ctx.data_state.zones.is_failed,
                          "is-invalid": _ctx.validation$.zoneId.$error,
                          "validation-errors": _ctx.validation$.zoneId.$errors,
                          "error-text": "При получении списка зон произошла ошибка",
                          "can-deselect": "",
                          label: "description",
                          onRefresh: _ctx.loadZones
                        }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_15,
                        _createVNode(_component_new_select, {
                          value: _ctx.payload.logistId,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payload.logistId) = $event)),
                          placeholder: "Выберите из списка",
                          options: _ctx.data_state.logists.list,
                          loading: _ctx.data_state.logists.is_loading,
                          failed: _ctx.data_state.logists.is_failed,
                          disabled: _ctx.loading,
                          "error-text": "При получении списка логистов произошла ошибка",
                          onRefresh: _ctx.loadLogists,
                          onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreLogists(_ctx.data_state.logists.pagination.current_page + 1))),
                          onSearch: _ctx.searchLogists,
                          onOptionBySearch: _ctx.unshiftFindedLogist,
                          "infinite-scroll": ""
                        }, null, 8, ["value", "options", "loading", "failed", "disabled", "onRefresh", "onSearch", "onOptionBySearch"])
                      ]),
                      _createVNode(_component_new_checkbox, {
                        class: "checkbox--blue",
                        value: _ctx.payload.isActive,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payload.isActive) = $event)),
                        disabled: _ctx.loading,
                        label: "Активировать направление",
                        "return-integer": ""
                      }, null, 8, ["value", "disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isSla)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_radio_group, {
                          class: "small mt-2",
                          name: "sla_tab",
                          value: _ctx.state.current_tab_sla,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.current_tab_sla) = $event)),
                          options: _ctx.SLA_TABS
                        }, null, 8, ["value", "options"])
                      ]),
                      (_ctx.isLtlSla)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payload.sla.ltl, (row, i) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: `row-${i}`
                                }, [
                                  (_ctx.isSubRow(i))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(row.tariff === 'standart' ? 'Стандарт' : 'Экспресс'), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", _hoisted_21, _toDisplayString(row.periodId === 1 ? 'Летнее' : 'Зимнее') + " время ", 1),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_new_input, {
                                      disabled: _ctx.loading,
                                      value: row.pickup,
                                      "onUpdate:value": ($event: any) => ((row.pickup) = $event)
                                    }, null, 8, ["disabled", "value", "onUpdate:value"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_new_input, {
                                      disabled: _ctx.loading,
                                      value: row.processing,
                                      "onUpdate:value": ($event: any) => ((row.processing) = $event)
                                    }, null, 8, ["disabled", "value", "onUpdate:value"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_new_input, {
                                      disabled: _ctx.loading,
                                      value: row.transit,
                                      "onUpdate:value": ($event: any) => ((row.transit) = $event)
                                    }, null, 8, ["disabled", "value", "onUpdate:value"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_new_input, {
                                      disabled: _ctx.loading,
                                      value: row.delivery,
                                      "onUpdate:value": ($event: any) => ((row.delivery) = $event)
                                    }, null, 8, ["disabled", "value", "onUpdate:value"])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isFtlSla)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payload.sla.ftl, (row, i) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: `row-${i}`
                                }, [
                                  (_ctx.isSubRow(i))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(row.tariff === 'standart' ? 'Стандарт' : 'Экспресс'), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", _hoisted_25, _toDisplayString(row.periodId === 1 ? 'Летнее' : 'Зимнее') + " время ", 1),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_new_input, {
                                      disabled: _ctx.loading,
                                      value: row.pickup,
                                      "onUpdate:value": ($event: any) => ((row.pickup) = $event)
                                    }, null, 8, ["disabled", "value", "onUpdate:value"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_new_input, {
                                      disabled: _ctx.loading,
                                      value: row.processing,
                                      "onUpdate:value": ($event: any) => ((row.processing) = $event)
                                    }, null, 8, ["disabled", "value", "onUpdate:value"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_new_input, {
                                      disabled: _ctx.loading,
                                      value: row.transit,
                                      "onUpdate:value": ($event: any) => ((row.transit) = $event)
                                    }, null, 8, ["disabled", "value", "onUpdate:value"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_new_input, {
                                      disabled: _ctx.loading,
                                      value: row.delivery,
                                      "onUpdate:value": ($event: any) => ((row.delivery) = $event)
                                    }, null, 8, ["disabled", "value", "onUpdate:value"])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isCost)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payload.capacities, (capacity, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `capacity-${i}`
                            }, [
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createVNode(_component_new_input, {
                                  placeholder: "Вес",
                                  disabled: _ctx.state.is_loading,
                                  value: capacity.weightLoadStandard,
                                  "onUpdate:value": ($event: any) => ((capacity.weightLoadStandard) = $event),
                                  type: "number"
                                }, null, 8, ["disabled", "value", "onUpdate:value"])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createVNode(_component_new_input, {
                                  placeholder: "Кубатура",
                                  disabled: _ctx.state.is_loading,
                                  value: capacity.cubatureLoadStandard,
                                  "onUpdate:value": ($event: any) => ((capacity.cubatureLoadStandard) = $event),
                                  type: "number"
                                }, null, 8, ["disabled", "value", "onUpdate:value"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isInternal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("a", _hoisted_36, [
                        _hoisted_37,
                        _createVNode(_component_export_icon, { class: "ml-2" })
                      ]),
                      _createElementVNode("div", {
                        class: "Internal__draggable",
                        onDragover: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.isDragging = true), ["prevent"])),
                        onDragleave: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.isDragging = false), ["prevent"])),
                        onDrop: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("label", {
                          for: "fileInput",
                          class: _normalizeClass(["Internal__field", {
                            'border-blue-400 text-blue-500 bg-blue-50': _ctx.isDragging,
                            'border-gray-300 text-gray-500': !_ctx.isDragging,
                        }])
                        }, [
                          _createVNode(_component_upload_icon, { class: "Internal__cloud" }),
                          _hoisted_38,
                          _hoisted_39,
                          _createElementVNode("input", {
                            id: "fileInput",
                            type: "file",
                            class: "hidden",
                            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleFile && _ctx.handleFile(...args)))
                          }, null, 32)
                        ], 2)
                      ], 32),
                      (_ctx.file)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createVNode(_component_excel_icon, { class: "mr-2" }),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.file.name), 1),
                              _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.formatSize(_ctx.file.size)), 1)
                            ]),
                            _createVNode(_component_times_grey_icon, {
                              class: "Internal__delete",
                              onClick: _ctx.removeFile
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      }, 8, ["title", "loading", "onSubmit", "onCancel"]))
}